import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import { Layout, Menu } from "antd";
const { Header } = Layout;
import { entitiesNavs, pageNavs, userNavs } from "./constants/navOptions";
import { isAllowed } from "shared/Auth";

import styles from "./index.scss";

const SecondaryHeader = ({ location, isMobile }) => {
	const [navs, setNavs] = useState([]);

	useEffect(() => {
		const path = location.pathname.split("/")[1];
		switch (path) {
			case "entities":
				setNavs(entitiesNavs);
				break;
			case "users":
				setNavs(userNavs);
				break;
			case "content":
				setNavs(pageNavs);
				break;
			default:
				setNavs([]);
		}
	}, [location]);

	return (
		<>
			{navs.length > 0 ? (
				<Header className={styles.root}>
					<Menu
						mode="horizontal"
						size="small"
						forceSubMenuRender
						selectedKeys={location.pathname.split("/")[2]}
						style={{
							width: isMobile ? "1000px" : "100%",
							textAlign: isMobile ? "left" : "center",
							borderColor: "rgb(224, 227, 237)",
						}}
					>
						{navs.map((obj) => {
							return (
								<Menu.Item
									key={obj.key}
									disabled={obj.feature && !isAllowed(obj.feature)}
								>
									<NavLink to={obj.path}>{obj.name}</NavLink>
								</Menu.Item>
							);
						})}
					</Menu>
				</Header>
			) : null}
		</>
	);
};

SecondaryHeader.propTypes = {
	location: PropTypes.object,
	isMobile: PropTypes.bool,
};

export default SecondaryHeader;
